export default "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.4.8h63.2V64H.4z\"/><path id=\"XMLID_82_\" class=\"st1\" d=\"M.4 0l33.1 32.2-33.1 31z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M32 .5l31.6 15.8L32 32.2z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M32 31.8l31.6-.2L32 63.5z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./static/symbols/11.svg
// module id = 51
// module chunks = 0